import MyTeam from './pages'
import OrgChart from './pages/OrgChart.vue'
import LoadLicence from './pages/LoadLicence.vue'
import Dashboard from './pages/Dashboard.vue'
const router = {
  name: 'manager',
  path: 'manager',
  component: MyTeam,
  children: [
    {
      path: '/myteam',
      name: 'Myteam',
      component: OrgChart,
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 113,
        titleHeader: 'Organigrama'
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        titleHeader: 'Dashboard'
      }
    },
    {
      name: 'loadTeamLicence',
      path: '/loadLicence',
      component: LoadLicence,
      meta: {
        titleHeader: 'Cargar ausencia'
      },
    }
  ]
}

export default router